import { createContext, useContext, useReducer } from 'react';

const LoginUserContext = createContext(null);

const LoginUserDispatchContext = createContext(null);

export const LoginUserProvider = ({ children }) => {
	const [loginUser, dispatch] = useReducer(loginUserReducer, initialUserData);

	return (
		<LoginUserContext.Provider value={loginUser}>
			<LoginUserDispatchContext.Provider value={dispatch}>
				{children}
			</LoginUserDispatchContext.Provider>
		</LoginUserContext.Provider>
	);
};

export const useLoginUser = () => useContext(LoginUserContext);

export const useLoginUserDispatch = () => useContext(LoginUserDispatchContext);

export const LoginActions = {
	setUser: 'setUser',
	reset: 'reset'
};

const loginUserReducer = (state, msg) => {
	const { setUser, reset } = LoginActions;
	switch (msg.action) {
		case setUser:
			return {
				...state,
				userId: msg.payload.userId,
				user: msg.payload.user,
				isAdmin: msg.payload.isAdmin,
				canRegisterMap: msg.payload.canRegisterMap,
				isPaycor: msg.payload.isPaycor,
				canSkipTaxes: msg.payload.canSkipTaxes,
				canDisableAutoCancel: msg.payload.canDisableAutoCancel
			};
		case reset:
			return {
				...initialUserData
			};
		default:
			console.warn(
				'loginUserReducer: Encountered an unknown reducer action:' + msg.action
			);
			break;
	}
};

const initialUserData = {
	userId: '',
	user: {},
	isAdmin: false,
	canRegisterMap: false,
	isPaycor: false,
	canSkipTaxes: false,
	canDisableAutoCancel: false
};
